import styled from 'styled-components';

const ErrorToast = styled.div`
    position: fixed;
    bottom: 12px;
    left: -300px;
    border-radius: 16px;
    padding: 12px;
    color: red;
    border: 1px solid red;
    background-color: white;
    font-size: 1rem;
    transition: left 500ms;
    visibility: hidden;
    margin-right: 24px;
    &.sliding {
        left: 24px;
        visibility: visible;
    }
`;

export default ErrorToast;


// WEBPACK FOOTER //
// ./src/SharedComponents/ErrorToast.tsx